'use strict';

/**
 * Инциализация mmenu
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */
function mMenu (selector) {
	let $menu = $(selector);
	$menu.mmenu({
		navbar: {
			title: 'Wezom'
		},
		backButton: true,
		extensions: [
			'fullscreen'
		],
		navbars: [{
			position: 'top',
			content: [`<button id="close-menu" class="link-burger"><span class="link-burger__icon"></span></button>`]
		},true]
	});

	var API = $menu.data("mmenu");

	$("#close-menu").click(function() {
		API.close();
	});
}

function loadMenu () {
	if (typeof $.mmenu === 'undefined' && $(window).width() < 1025) {
		require.ensure([], () => {
			require('_vendors/jquery.mmenu');
			require('_vendors/mmenu.scss');
			mMenu('#js-mmenu');
		}, 'mmenu');
	}
}

(function ($) {
	loadMenu();

	$(window).resize(() => {
		loadMenu();
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/mmenu.js